<template>
  <div class="turnover_wrap" @scroll="handleScroll" >
    <custom-tabs :tab-list="tabList" :value="isDirect" @change="tabChange" >
      <div class="date" slot="extra" @click="dateSelect" ></div>
      <div class="tabs_wrap"  >
        <div class="order_wrap" >
          <div class="order_search" >
            <van-field placeholder="订单编号/会员昵称/会员编号" class="order_input" v-model="search" >
              <template #button>
                <van-icon name="search" class="search_icon" @click="searchOrder" />
              </template>
            </van-field>
          </div>

          <div class="statistics_wrap" >
            <div class="statistics_item" >
              <div>
                <div class="money" ></div>
                营业额
              </div>
              <div>￥{{ turnover }}</div>
            </div>

            <div class="statistics_item" >
              <div>
                <div class="order" ></div>
                订单数
              </div>
              <div>{{ storeOrderCount }}</div>
            </div>
          </div>

          <div class="order_tabs" >
            <div class="order_tabs_item"
                 v-for="(item, index) in orderTabs" :key="item.id"
                 @click="orderTabChange(item.id)"
                 :class="{ 'order_active': item.id === storeOrderStatus }"
            >{{ item.name }}</div>
          </div>
        </div>

        <div class="order_list" >
          <div class="order_item" @click="orderDetail(item.orderInfoId)"  v-for="(item, index) in storeOrderVoList" :key="index" >
            <div class="order_title" >
              <div>订单编号：{{ item.orderId }}</div>
              <div class="complete_status" >{{ item.showStatusStr }}</div>
            </div>
            <div class="order_time" >支付时间：{{ item.payTime }}</div>
            <div class="order_goods_wrap" >
              <van-image :src="item.skuImg" class="goods_info_img" radius="5px" />
              <div class="order_goods_info" >
                <div>{{ item.productName }}</div>
                <div>
                  <div>{{ item.productOnePrice }}</div>
                  <div>x{{ item.payNum }}</div>
                </div>
              </div>
            </div>
            <div class="user_info" >
              <van-image :src="item.headImgUrl" round class="head_img" />
              <div class="user_right" >
                <div>{{ item.nikeName }}</div>
                <div>
                  <div>应付金额：¥{{ item.totalPrice }}</div>
                  <div>实付金额：¥{{ item.payPrice }}</div>
                </div>
              </div>
            </div>
            <div class="order_footer" >
              <div :style="{ visibility: item.commission ? 'visible' : 'hidden' }" >佣金：￥{{ item.commission }}</div>
              <div class="share_btn" v-if="item.refundStatus === '0'" >
                <div class="share" ></div>
                <div @click.stop="shareOrder(item)"  >晒单</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <van-empty description="暂无数据" v-if="storeOrderVoList.length <= 0" />
    </custom-tabs>

    <van-popup v-model="showShare">
      <img :src="poster" v-if="poster" class="poster" />
      <template  v-else >
        <div class="share_wrap" ref="share" >
          <div class="buy_success" ></div>
          <div class="share_head" >
            <div class="share_order_no" >下单回执</div>
            <div class="share_other_info" >
              <div>
                <div>订单流水</div>
                <div>{{ orderVo.orderId }}</div>
              </div>
              <div>
                <div>下单时间</div>
                <div>{{ orderVo.payTime }}</div>
              </div>
            </div>
          </div>

          <template >
            <div class="share_goods"  >
              <img :src="orderVo.skuImg" class="share_img" />
              <div class="share_goods_right" >
                <div>{{ orderVo.productName }}</div>
                <div>
                  <div>{{ orderVo.productOnePrice }}</div>
                  <div>x {{ orderVo.payNum }}</div>
                </div>
              </div>
            </div>
          </template>

<!--          <template v-if="orderVo.orderProductDetailVoList.length === 1"  >
            <div class="share_goods" :key="index" v-for="(item, index) in orderVo.orderProductDetailVoList" >
              <img :src="item.image" class="share_img" />
              <div class="share_goods_right" >
                <div>{{ item.productName }}</div>
                <div>
                  <div>{{ item.price }}</div>
                  <div>x {{ item.payNum }}</div>
                </div>
              </div>
            </div>
          </template>

          <template v-else >
            <div class="more_share_wrap" >
              <div class="goods_list" >
                <div class="goods_item" v-if="index <=2" v-for="(item, index) in orderVo.orderProductDetailVoList" :key="index" >
                  <img :src="item.image" />
                </div>
              </div>
              <div class="share_count" >共 {{ orderVo.orderProductDetailVoList.length }} 件</div>
            </div>
          </template>-->


          <div class="share_address_wrap" >
            <div class="share_address_item" >
              <div>收货人</div>
              <div>{{ orderVo.realName }}</div>
            </div>

            <div class="share_address_item" >
              <div>联系方式</div>
              <div>{{ orderVo.userPhone }}</div>
            </div>

            <div class="share_address_item" >
              <div>收货地址</div>
              <div>{{ orderVo.userAddress }}</div>
            </div>
          </div>

          <div class="share_money_wrap" >
            <div>订单总额</div>
            <div>
              <div class="share_total_money" >￥{{ orderVo.payPrice }}</div>
              <div class="share_postage" v-if="parseFloat(orderVo.payPostage) > 0" >（含运费¥{{ orderVo.payPostage }}）</div>
            </div>
          </div>

          <div class="share_logo_wrap" >
            <div class="share_logo" ></div>
          </div>
        </div>
      </template>
      <div class="close" @click="showShare = false" ></div>
    </van-popup>

    <calendar @change="onChange" :show.sync="showDate" mode="during" />
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import html2canvas from 'html2canvas'
import {
  getMyStoreOrderListByPage,
  getStoreOrderNum,
  getStoreOrderInfo
} from '@/api/order'
import { Toast } from "vant";
import moment from 'moment'
export default {
  name: 'turnoverDetail',
  data() {
    return {
      isDirect: 0,
      tabList: ['直接订单', '间接订单'],
      orderTabs: [
        { id: 1, name: '全部' },
        { id: 2, name: '未发货' },
        { id: 3, name: '待收货' },
        { id: 4, name: '已完成' },
        { id: 5, name: '退款/售后' }
      ],
      storeOrderStatus: 1,
      showShare: false,
      search: '',
      page: 1,
      pageSize: 10,
      storeOrderCount: 0,
      turnover: 0,
      storeOrderVoList: [],
      showDate: false,
      startTime: undefined,
      endTime: undefined,
      share_img: '',
      orderVo: {
        orderProductDetailVoList: []
      },
      qrcode: '',
      poster: ''
    }
  },
  methods:{
    getPixelRatio (context) {
      var backingStore = context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio || 1
      return (window.devicePixelRatio || 1) / backingStore
    },
    get_img (id) {
      const _this = this
      // 生成海报
      html2canvas(id, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true,
        onclone(doc) {
          // console.log(doc)
        }
      }).then(function(canvas) {
        _this.poster = canvas.toDataURL('image/png')
        Toast.clear()
        Toast.resetDefaultOptions()
      })
    },
    onChange(date){
      if(date.length > 1) {
        this.startTime = moment(date[0].$d).format('YYYY-MM-DD')
        this.endTime = moment(date[1].$d).format('YYYY-MM-DD')
        this.page = 1
        this.storeOrderVoList = []
        this.getMyStoreOrderListByPage()
        this.showDate = false
      }
    },
    dateSelect() {
      this.showDate = true
    },
    handleScroll(e) {
      const {scrollTop, clientHeight, scrollHeight} = e.target
      if (scrollTop + clientHeight >= scrollHeight - 50){
        this.page++
        this.getMyStoreOrderListByPage()
      }
    },
    searchOrder() {
      this.storeOrderVoList = []
      this.getMyStoreOrderListByPage()
      this.getStoreOrderNum()
    },
    shareOrder(item) {
      this.showShare = true
      this.poster = ''
      Toast.loading({
        message: '海报生成中...',
        forbidClick: true,
        duration: 0
      });
      this.getStoreOrderInfo(item.orderId)
    },
    getStoreOrderInfo(orderId) {
      this.orderId = orderId
      getStoreOrderInfo({ orderId, isShield: '1' }).then(res => {
        if(res.success) {
          this.orderVo = {...res.data}
          setTimeout(() => {
            this.get_img(this.$refs.share)
          }, 1000)
        }
      })
    },
    orderTabChange(storeOrderStatus) {
      this.page = 1
      this.storeOrderVoList = []
      this.storeOrderStatus = storeOrderStatus
      this.getMyStoreOrderListByPage()
      this.getStoreOrderNum()
    },
    tabChange(isDirect) {
      this.page = 1
      this.storeOrderVoList = []
      this.isDirect = isDirect
      this.getMyStoreOrderListByPage()
      this.getStoreOrderNum()
    },
    orderDetail(orderId) {
      this.$router.push({ name: 'orderDetail', params: { orderId } })
    },
    getStoreOrderNum() {
      const { isDirect, search } = this;
      let values = { isDirect, search }
      let copy = JSON.parse(JSON.stringify(isDirect))
      values.isDirect = copy  === 0 ? 1 : 0
      getStoreOrderNum({ ...values }).then(res => {
        if(res.success) {
          this.storeOrderCount = res.data.storeOrderCount
          this.turnover = res.data.turnover
        }
      })
    },
    getMyStoreOrderListByPage() {
      const { page, pageSize, search, storeOrderStatus, isDirect, startTime, endTime } = this
      let values = { page, pageSize, search, storeOrderStatus, isDirect, startTime, endTime }
      let copy = JSON.parse(JSON.stringify(isDirect))
      values.isDirect = copy  === 0 ? 1 : 0
      getMyStoreOrderListByPage({...values}).then(res => {
        if(res.success) {
          this.storeOrderVoList = this.storeOrderVoList.concat(res.data)
          console.log([...this.storeOrderVoList])
        }
      })
    },
  },
  mounted() {
    this.getMyStoreOrderListByPage()
    this.getStoreOrderNum()
  }
}
</script>
